import { OPTIMIZELY_FLAGS_ENUM } from '@/constants'
import { OptimizelyDecisionsProps } from '@/context/optimizely-decisions-context'

import {
  getExplorationSets,
  type ExplorationLocation,
  type ExplorationTile,
} from './data'

export interface ResolvedExplorationVariant {
  location: ExplorationLocation
  tiles: ExplorationTile[]
}

export const resolveExplorationVariant = (
  placesId: string | undefined,
  optiContext: OptimizelyDecisionsProps,
): ResolvedExplorationVariant | null => {
  if (optiContext.isGuestApp) {
    return null
  }

  const sets = getExplorationSets(placesId)

  if (!sets) {
    return null
  }

  const variation = optiContext.getExperimentVariationKey(
    OPTIMIZELY_FLAGS_ENUM.AS_2696_CORNWALL_EXPLORATION,
  )

  if (variation === 'variant_a') {
    return { location: sets.location, tiles: sets.v1 }
  }

  if (variation === 'variant_b') {
    return { location: sets.location, tiles: sets.v2 }
  }

  return null
}
